import React, {Component} from 'react'
import './auth.css'
import {auth} from './firebase'

class Auth extends Component{
    state={
        status:"login",
        email:"",
        password:""
    }
handleRegister = () => {
    auth.createUserWithEmailAndPassword(
        this.state.email,
        this.state.password
    )
}
handlelogin = () => {
    auth.signInWithEmailAndPassword(
        this.state.email,
        this.state.password
    )
}
handleStatus = () => {
    if (this.state.status === "login"){
        this.setState({
            status:"reg"
        })
    } else {
        this.setState({
            status:"login"
        })
    }
}
    render(){
        return(
            <React.Fragment>
                <div className="auth">
                    {
                    
                            this.state.status === "login" ? (
                                <div className="login">
                                    <input onChange={(event)=>{
                                        this.setState({email: event.target.value})
                                    }} 
                                    type="text" />
                                    <input onChange={(event)=>{
                                        this.setState({password: event.target.value})
                                    }}
                                    type="password" />
                                    <button onClick={this.handlelogin}>Login</button>
                                    <p>akauntiz yo bosa <span onClick={this.handleStatus}>akaunt ochin</span></p>
                                </div>
                            )  : (
                                <div className="reg">
                                    <input type="text"
                                    onChange={(event)=>{
                                        this.setState({email: event.target.value})
                                    }} />
                                    <input type="password" className="password" 
                                    onChange={(event)=>{
                                        this.setState({password:event.target.value})
                                    }}
                                    />
                                    <button onClick={this.handleRegister}>regis</button>
                                    <p>akauntz bosa <span onClick={this.handleStatus}>login qln</span></p>
                                </div>
                            )
                                
                            }
                            
                </div>
            </React.Fragment>
        )      
             }
            }
export default Auth